import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth/auth.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit, AfterViewInit {
  loadingIcon = true;
  singleOrg = true;
  @Input() loggedIn: any;
  disableOrgChange = false;
  loggedInUser: any = '';
  orgCount = 0;
  orgOpened = false;
  selectedOrg: any;
  currPerm: any[];

  constructor(
    private authService: AuthService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
      this.authService.checkorgCount$.subscribe(
        count => {
          this.orgCount = parseInt(count);
        });
      this.setUserInfo();
    } else {
      this.authService.redirectToUserError();
    }
  }

  ngAfterViewInit(): void {
    this.authService.isInEditMode$().forEach(message => { this.disableOrgChange = !message; });
  }

  setUserInfo() {
    this.authService.getLoggedInUserInfo().subscribe(response => {
      if (response && response.claims && response.values) {
        this.authService.processInitialResponse(response);
        this.authService.getDarkFeatureValue();
      }
      this.loadingIcon = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.loadingIcon = false;
      });
  }

  setActiveClass(link: string) {
    const paths = location.pathname.replace(/\//g, ',').split(',');
    return paths.length > 1 && link === paths[1] ? 'text-red' : 'text-black';
  }
}
